import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    Injectable,
    OnInit,
    Renderer2,
    ViewChild
} from '@angular/core';
import {formatDate} from '@angular/common';
import {Platform} from '@angular/cdk/platform';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {DatetimeFieldConfig} from '../datetime-field-config';
import {NgxMatDatetimepicker} from '@angular-material-components/datetime-picker';
import {Subscription} from 'rxjs';
import {untilDestroyed} from '@ngneat/until-destroy';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'mydocma-form-datetime-field',
    templateUrl: './datetime-field.component.html',
    styleUrls: ['./datetime-field.component.scss']
})
export class DatetimeFieldComponent extends BaseFieldComponent<DatetimeFieldConfig> implements OnInit, AfterViewInit {
    @ViewChild('picker', {static: false}) picker: NgxMatDatetimepicker<any>;
    public readonly staticCssClass = 'mydocma-datetime-field';
    private subscription: Subscription;
    public isInitialized: boolean;

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        private readonly translateService: TranslateService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    public onClick() {
        if (!this.fieldWrapper.config.readonly) {
            setTimeout(() => {
                this.picker.open();
            });
        }
        super.onControlClick();
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngAfterViewInit(): void {
        queueMicrotask(() => {
            this.isInitialized = true;
            this.changeDetectorRef.detectChanges();
        });

        // this code my not be relevant anymore, were addded to prvent closing picker when select date in picker
        // this.picker.openedStream.pipe(untilDestroyed(this)).subscribe(() => {
        //     this.subscription?.unsubscribe();
        //     setTimeout(() => {
        //         const calendar = (this.picker as any)._componentRef?.instance?._calendar;
        //         if (calendar) {
        //             this.subscription = calendar._userSelection.asObservable().pipe(untilDestroyed(this)).subscribe(() => {
        //                 this.picker.open();
        //             });
        //         }
        //     });
        // });
    }

    public isEnglishLanguage(): boolean {
        return this.translateService.currentLang?.toLowerCase().startsWith('en');
    }


}
